module.exports = __webpack_public_path__ + "img/image-button.7c9b2456.svg";